import "./comingSoon.css";

const ComingSoon = ({ title }) => {
  return (
    <div className="comingsoon-page">
      <div className="comingsoon-content">
        <img src="/assets/images/login-logo.png" alt="" />
        <h1>{title}</h1>
        <h1>Coming Soon...</h1>
      </div>
    </div>
  );
};

export default ComingSoon;
